import { useFormContext } from 'react-hook-form'
import Button from './button'
import { cx } from '@emotion/css'

const SubmitButton = ({ className, children, loading: _loading, disabled: _disabled, ...props }) => {
	const formContext = useFormContext()
	const isSubmitting = formContext?.formState?.isSubmitting

	const loading = _loading ?? isSubmitting
	const disabled = _disabled ?? isSubmitting

	return (
		<Button {...props} className={cx('SubmitButton', className)} loading={loading} disabled={disabled} type="submit">
			{children}
		</Button>
	)
}

export default SubmitButton
